import { Card, Button } from 'react-bootstrap';
import { AdminCardProps } from '../../pages/interfaces/AdminCardUI';
import CustomToolTip from '../../components/containers/CustomToolTip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

const AdminCard = ({ title, buttons }: AdminCardProps) => {
    return (
        <Card className="mt-4">
            <Card.Header>
                <Card.Title className="text-center">{title}</Card.Title>
            </Card.Header>
            <Card.Body className="d-flex flex-column">
                {buttons.map((buttonProps) =>
                    buttonProps.toolTipText ? (
                        <CustomToolTip
                            placement="bottom"
                            displayText={buttonProps.toolTipText}
                            id={`${title}-tooltip`}
                        >
                            <Button
                                key={`${title}-${buttonProps.btnText}`}
                                onClick={buttonProps.onClick}
                                variant={buttonProps.variant}
                                className="my-2"
                            >
                                {buttonProps.btnText}{' '}
                                {
                                    <FontAwesomeIcon
                                        icon={faExclamationTriangle as IconProp}
                                        color="yellow"
                                    />
                                }
                            </Button>
                        </CustomToolTip>
                    ) : (
                        <Button
                            key={`${title}-${buttonProps.btnText}`}
                            onClick={buttonProps.onClick}
                            variant={buttonProps.variant}
                            className="my-2"
                        >
                            {buttonProps.btnText}
                        </Button>
                    )
                )}
            </Card.Body>
        </Card>
    );
};

export default AdminCard;
